import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@wfp/react';
import type { FC } from 'react';
import React from 'react';

import { AI_MIN_SELECTION_WORDS } from './constants';

interface Props {
  onClose: () => void;
  onStopShowing: () => void;
}

const ContextualActionsHint: FC<Props> = ({ onClose, onStopShowing }) => (
  <div
    className="ai-contextual-hint"
    role="note"
    data-test-id="ai-contextual-hint"
  >
    <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
    <span>
      <strong>Tip:</strong>{' '}
      {`select any text in the narrative (at least ${AI_MIN_SELECTION_WORDS} words) to improve it with the help of AI.`}
    </span>
    <div className="ai-contextual-hint-actions">
      <Button
        small
        kind="ghost"
        onClick={onClose}
        data-test-id="ai-contextual-hint-close"
      >
        Close
      </Button>
      <Button
        small
        kind="ghost"
        onClick={onStopShowing}
        data-test-id="ai-contextual-hint-stop"
      >
        Don&apos;t show again
      </Button>
    </div>
  </div>
);

export default ContextualActionsHint;
